function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import styled from "styled-components";

var HamburgerToggleIcon = function HamburgerToggleIcon(_ref) {
  var toggle = _ref.toggle,
      inverted = _ref.inverted,
      restProps = _objectWithoutProperties(_ref, ["toggle", "inverted"]);

  return React.createElement(
    Wrapper,
    restProps,
    React.createElement(LineTop, { className: toggle && "open", inverted: inverted }),
    React.createElement(LineMid, { className: toggle && "open", inverted: inverted }),
    React.createElement(LineBot, { className: toggle && "open", inverted: inverted })
  );
};

export { HamburgerToggleIcon };
var Wrapper = styled.div.withConfig({
  displayName: "HamburgerToggleIcon__Wrapper",
  componentId: "sc-1qbyh3t-0"
})(["position:relative;height:24px;width:24px;cursor:pointer;"]);

var LineBase = styled.div.withConfig({
  displayName: "HamburgerToggleIcon__LineBase",
  componentId: "sc-1qbyh3t-1"
})(["position:absolute;width:25px;height:3px;border-radius:2px;background-color:", ";", ";&.open{background-color:white;}transition:all 250ms cubic-bezier(0.14,1.1,0.56,1.65);&.open{transition:all 200ms cubic-bezier(0.19,0.83,0.14,0.99);background-color:white;}"], function (props) {
  return props.theme.textMedium;
}, function (props) {
  return props.inverted && "background-color: " + props.theme.primary + ";";
});

var LineTop = styled(LineBase).withConfig({
  displayName: "HamburgerToggleIcon__LineTop",
  componentId: "sc-1qbyh3t-2"
})(["top:20%;&.open{transform:rotate(-45deg);top:50%;}"]);

var LineMid = styled(LineBase).withConfig({
  displayName: "HamburgerToggleIcon__LineMid",
  componentId: "sc-1qbyh3t-3"
})(["top:50%;&.open{transform:rotate(90deg);top:50%;opacity:0;}"]);

var LineBot = styled(LineBase).withConfig({
  displayName: "HamburgerToggleIcon__LineBot",
  componentId: "sc-1qbyh3t-4"
})(["top:80%;&.open{transform:rotate(45deg);top:50%;}"]);